import React from "react";
import {
  FaCircleCheck,
  FaClock,
  FaCircleXmark,
  FaCircleMinus,
} from "react-icons/fa6";

const ApprovalFlowHorizontal = ({ approvalHierarchy }) => {
  if (!approvalHierarchy || approvalHierarchy.length === 0) {
    return (
      <p className="text-gray-500 dark:text-gray-400 text-center py-4 text-sm transition-colors duration-300">
        No approval flow available.
      </p>
    );
  }

  const extractedApprovalHierarchy =
    approvalHierarchy.length > 0 ? approvalHierarchy[0].approvalHierarchy : [];

  return (
    <div
      className="w-full overflow-x-auto"
      style={{ scrollbarWidth: "thin", scrollbarColor: "#4b5563 transparent" }}
    >
      <div
        className="flex items-center justify-start sm:justify-center w-max sm:w-full py-6 relative gap-8 sm:gap-12 px-2 transition-colors duration-300"
      >
        {extractedApprovalHierarchy.map((step, index) => (
          <div key={index} className="flex flex-col items-center relative min-w-[90px] sm:min-w-[120px]">
            {/* Timeline line */}
            {index !== 0 && (
              <div
                className="absolute top-1/2 left-[-50%] w-full h-0.5 
                           bg-gray-200 dark:bg-gray-700 -z-10 transition-colors duration-300"
              ></div>
            )}

            {/* Icon circle */}
            <div
              className="flex items-center justify-center w-10 h-10 sm:w-12 sm:h-12 rounded-full 
                         border border-gray-200 dark:border-gray-700 
                         bg-white dark:bg-gray-800 shadow-sm transition-colors duration-300"
            >
              {step.status === "Approved" ? (
                <FaCircleCheck className="text-green-500 text-xl sm:text-2xl" />
              ) : step.status === "Rejected" ? (
                <FaCircleXmark className="text-red-500 text-xl sm:text-2xl" />
              ) : step.status === "Canceled" ? (
                <FaCircleMinus className="text-gray-400 dark:text-gray-500 text-xl sm:text-2xl" />
              ) : (
                <FaClock className="text-yellow-500 text-xl sm:text-2xl" />
              )}
            </div>

            {/* Approver Name */}
            <span className="mt-2 text-gray-700 dark:text-gray-200 font-medium text-xs sm:text-sm text-center w-24 sm:w-28 truncate transition-colors duration-300">
              {step.approver}
            </span>

            {/* Status */}
            <span
              className={`text-xs sm:text-sm font-medium mt-0.5 transition-colors duration-300
                ${
                  step.status === "Approved"
                    ? "text-green-600 dark:text-green-400"
                    : step.status === "Rejected"
                    ? "text-red-600 dark:text-red-400"
                    : step.status === "Canceled"
                    ? "text-gray-500 dark:text-gray-400"
                    : "text-yellow-600 dark:text-yellow-400"
                }`}
            >
              {step.status || "Pending"}
            </span>

            {/* Approved Date */}
            {step.approvedAt && (
              <span className="text-gray-400 dark:text-gray-500 text-[10px] sm:text-xs mt-0.5 transition-colors duration-300">
                {new Date(step.approvedAt).toLocaleDateString("th-TH", {
                  day: "numeric",
                  month: "short",
                  year: "numeric",
                })}
              </span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ApprovalFlowHorizontal;
